
export class ProcessedEntityPaymentExtension {
}
